/**
 * shared/components/SkeletonTable.jsx
 *
 * Renders a <tbody> with animated skeleton rows.
 * Must be placed directly inside a <table> — renders its own <tbody>.
 *
 * Props:
 *   rows  — number of skeleton rows to show (default: 5)
 *   cols  — number of columns (default: 6)
 */

export function SkeletonTable({ rows = 5, cols = 6 }) {
    return (
      <tbody>
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <tr key={rowIndex} className="border-b border-gray-100">
            {Array.from({ length: cols }).map((_, colIndex) => (
              <td key={colIndex} className="px-6 py-4">
                <div
                  className="h-4 bg-gray-200 rounded animate-pulse"
                  style={{ width: `${60 + Math.random() * 30}%` }}
                />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    );
  }
  
  export default SkeletonTable;